<template>
  <div
    class="w-full pt-24 pb-16 bg-top-section bg-cover bg-center bg-no-repeat overflow-hidden"
  >
    <div class="flex justify-center flex-col items-center">
      <div class="flex items-center max-w-130">
        <img :src="`${imgPath}/latale-logo-nav.png`" />
      </div>
      <div class="w-full max-w-356 flex items-center -mt-5">
        <img :src="`${imgPath}/slide1/title.png`" />
      </div>
      <a
        class="flex items-center -mt-8"
        href="https://www.youtube.com/watch?v=XvbrZsOjgTA"
        data-lity
      >
        <img :src="`${imgPath}/slide1/play_btn.png`" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
};
</script>

<style></style>
